import React, { useState, useEffect } from 'react';
import { FaTiktok,FaWhatsapp, FaFacebook, FaInstagram, FaGem, FaNewspaper, FaRocket, FaBuilding } from 'react-icons/fa';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button,
  Input,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Spinner,
  Alert,
  InputGroup,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { supabase } from '../services/supabaseClient';

const CatalogoProveedores = ({ user }) => {
  // Estados principales
  const [servicios, setServicios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Estados para filtros
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [filtroBusqueda, setFiltroBusqueda] = useState('');
  const [filtroUbicacion, setFiltroUbicacion] = useState('');
  const [ordenamiento, setOrdenamiento] = useState('recientes');
  
  // Estados para modales
  const [modalPublicar, setModalPublicar] = useState(false);
  const [modalContactar, setModalContactar] = useState(false);
  const [modalDetalles, setModalDetalles] = useState(false);
  const [servicioSeleccionado, setServicioSeleccionado] = useState(null);
  
  // Estados para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(12);
  
  // Estados para dropdowns
  const [dropdownCategoria, setDropdownCategoria] = useState(false);
  const [dropdownOrden, setDropdownOrden] = useState(false);
  
  // Estado para nuevo servicio
  const [nuevoServicio, setNuevoServicio] = useState({
    titulo: '',
    categoria: '',
    categoria_personalizada: '',
    descripcion: '',
    ubicacion: '',
    empresa: '',
    ruc: '',
    telefono: '',
    email: '',
    whatsapp: '',
    website: '',
    facebook: '',
    instagram: '',
    tiktok: '',
    especialidades: '',
    experiencia_anos: '',
    experiencia_meses: ''
  });

  const [enviandoFormulario, setEnviandoFormulario] = useState(false);

  // Categorías predefinidas con colores mejorados
  const categorias = [
    { 
      id: 'construccion', 
      nombre: 'Construcción & Obras', 
      icono: '🏗️', 
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      imagen: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=250&fit=crop&auto=format'
    },
    { 
      id: 'consultoria', 
      nombre: 'Consultoría Empresarial', 
      icono: '📊', 
      color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      imagen: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=250&fit=crop&auto=format'
    },
    { 
      id: 'tecnologia', 
      nombre: 'Tecnología & Software', 
      icono: '💻', 
      color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      imagen: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=250&fit=crop&auto=format'
    },
    { 
      id: 'servicios_generales', 
      nombre: 'Servicios Generales', 
      icono: '🔧', 
      color: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      imagen: 'https://picsum.photos/id/292/400/250'
    },
    { 
      id: 'suministros', 
      nombre: 'Suministros & Materiales', 
      icono: '📦', 
      color: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
      imagen: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=250&fit=crop&auto=format'
    },
    { 
      id: 'salud', 
      nombre: 'Salud & Medicina', 
      icono: '🏥', 
      color: 'linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)',
      imagen: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=250&fit=crop&auto=format'
    },
    { 
      id: 'educacion', 
      nombre: 'Educación & Capacitación', 
      icono: '📚', 
      color: 'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)',
      imagen: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=400&h=250&fit=crop&auto=format'
    },
    { 
      id: 'transporte', 
      nombre: 'Transporte & Logística', 
      icono: '🚛', 
      color: 'linear-gradient(135deg, #fdbb2d 0%, #22c1c3 100%)',
      imagen: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=400&h=250&fit=crop&auto=format'
    },
    { 
      id: 'seguridad', 
      nombre: 'Seguridad & Vigilancia', 
      icono: '🛡️', 
      color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      imagen: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&h=250&fit=crop&auto=format'
    },
    { 
      id: 'limpieza', 
      nombre: 'Limpieza & Mantenimiento', 
      icono: '🧹', 
      color: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
      imagen: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=250&fit=crop&auto=format'
    },
    { 
      id: 'otros', 
      nombre: 'Otros Servicios', 
      icono: '⭐', 
      color: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
      imagen: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=250&fit=crop&auto=format'
    }
  ];

  const isAdmin = user?.email === 'consultingnuvia@gmail.com' || user?.role === 'ADMIN';

  useEffect(() => {
    loadServicios();
  }, [user]);

  // Cambiar la función loadServicios para procesar especialidades correctamente
  const loadServicios = async () => {
    setLoading(true);
    setError(null);
    
    try {
      let query = supabase
        .from('servicios_proveedores')
        .select('*')
        .order('created_at', { ascending: false });

      if (!isAdmin) {
        query = query.eq('estado', 'aprobado');
      }

      const { data, error } = await query;

      if (error) {
        throw error;
      }

      // CORRECCIÓN: Procesar especialidades de manera más robusta
      const serviciosProcesados = data.map(servicio => {
        let especialidadesProcesadas = [];
        
        if (servicio.especialidades) {
          if (Array.isArray(servicio.especialidades)) {
            // Si ya es un array, lo usamos directamente
            especialidadesProcesadas = servicio.especialidades.filter(s => s && s.trim());
          } else if (typeof servicio.especialidades === 'string') {
            try {
              // Intentar parsear como JSON primero
              const parsed = JSON.parse(servicio.especialidades);
              if (Array.isArray(parsed)) {
                especialidadesProcesadas = parsed.filter(s => s && s.trim());
              } else {
                throw new Error('No es array');
              }
            } catch {
              // Si falla el JSON.parse, tratar como string separado por comas
              especialidadesProcesadas = servicio.especialidades
                .split(',')
                .map(s => s.trim())
                .filter(s => s);
            }
          }
        }

        return {
          ...servicio,
          especialidades: especialidadesProcesadas
        };
      });

      setServicios(serviciosProcesados);
    } catch (error) {
      console.error('Error loading servicios:', error);
      setError('Error al cargar los servicios: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const getEstadoBadge = (estado) => {
    switch (estado) {
      case 'aprobado':
        return <Badge color="success" className="fw-bold">✅ Verificado</Badge>;
      case 'pendiente':
        return <Badge color="warning" className="fw-bold">⏳ En Revisión</Badge>;
      case 'rechazado':
        return <Badge color="danger" className="fw-bold">❌ Rechazado</Badge>;
      default:
        return <Badge color="secondary" className="fw-bold">❓ Sin Estado</Badge>;
    }
  };

  // Filtrar y ordenar servicios
  const serviciosFiltrados = servicios.filter(servicio => {
    const coincideCategoria = !filtroCategoria || servicio.categoria === filtroCategoria;
    const coincideBusqueda = !filtroBusqueda || 
      servicio.titulo?.toLowerCase().includes(filtroBusqueda.toLowerCase()) ||
      servicio.descripcion?.toLowerCase().includes(filtroBusqueda.toLowerCase()) ||
      servicio.empresa?.toLowerCase().includes(filtroBusqueda.toLowerCase());
    const coincideUbicacion = !filtroUbicacion || 
      servicio.ubicacion?.toLowerCase().includes(filtroUbicacion.toLowerCase());
    
    return coincideCategoria && coincideBusqueda && coincideUbicacion;
  }).sort((a, b) => {
    switch (ordenamiento) {
      case 'likes':
        return (b.likes || 0) - (a.likes || 0);
      default: // recientes
        return new Date(b.fecha_publicacion || b.created_at) - new Date(a.fecha_publicacion || a.created_at);
    }
  });

  // Paginación
  const totalPages = Math.ceil(serviciosFiltrados.length / itemsPerPage);
  const serviciosPaginados = serviciosFiltrados.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const getCategoriaInfo = (categoriaId, categoriaPersonalizada = null) => {
    if (categoriaId === 'otros' && categoriaPersonalizada) {
      return {
        id: 'otros',
        nombre: categoriaPersonalizada,
        icono: '⭐',
        color: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
        imagen: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=250&fit=crop&auto=format'
      };
    }
    
    const categoriaEncontrada = categorias.find(cat => cat.id === categoriaId);
    return categoriaEncontrada || categorias.find(cat => cat.id === 'otros');
  };

  // CORRECCIÓN 3: Implementar funciones de admin con Supabase real
  const handleAprobarServicio = async (servicioId) => {
    if (!isAdmin) {
      alert('No tienes permisos para realizar esta acción');
      return;
    }

    try {
      const { error } = await supabase
        .from('servicios_proveedores')
        .update({ 
          estado: 'aprobado',
          fecha_aprobacion: new Date().toISOString(),
          aprobado_por: user.email
        })
        .eq('id', servicioId);

      if (error) throw error;

      // Actualizar estado local
      setServicios(prevServicios => 
        prevServicios.map(servicio => 
          servicio.id === servicioId 
            ? { ...servicio, estado: 'aprobado' }
            : servicio
        )
      );
      
      alert('Servicio aprobado exitosamente');
    } catch (error) {
      console.error('Error approving service:', error);
      alert('Error al aprobar el servicio: ' + error.message);
    }
  };

  const handleRechazarServicio = async (servicioId) => {
    if (!isAdmin) {
      alert('No tienes permisos para realizar esta acción');
      return;
    }

    const motivo = prompt('Motivo del rechazo:');
    if (!motivo) return;

    try {
      const { error } = await supabase
        .from('servicios_proveedores')
        .update({ 
          estado: 'rechazado',
          fecha_rechazo: new Date().toISOString(),
          rechazado_por: user.email,
          motivo_rechazo: motivo
        })
        .eq('id', servicioId);

      if (error) throw error;

      // Actualizar estado local
      setServicios(prevServicios => 
        prevServicios.map(servicio => 
          servicio.id === servicioId 
            ? { ...servicio, estado: 'rechazado' }
            : servicio
        )
      );
      
      alert('Servicio rechazado');
    } catch (error) {
      console.error('Error rejecting service:', error);
      alert('Error al rechazar el servicio: ' + error.message);
    }
  };

  const handleEliminarServicio = async (servicioId) => {
    if (!isAdmin) {
      alert('No tienes permisos para realizar esta acción');
      return;
    }

    if (!window.confirm('¿Estás seguro de que deseas eliminar este servicio? Esta acción no se puede deshacer.')) {
      return;
    }

    try {
      // ELIMINAR DE LA BASE DE DATOS
      const { error } = await supabase
        .from('servicios_proveedores')
        .delete()
        .eq('id', servicioId);

      if (error) throw error;

      // Actualizar estado local
      setServicios(prevServicios => 
        prevServicios.filter(servicio => servicio.id !== servicioId)
      );
      
      alert('Servicio eliminado exitosamente');
    } catch (error) {
      console.error('Error deleting service:', error);
      alert('Error al eliminar el servicio: ' + error.message);
    }
  };

  // CORRECCIÓN 4: Guardar en Supabase en lugar de solo estado local
  const handlePublicarServicio = async (e) => {
    e.preventDefault();
    
    if (enviandoFormulario) return;
    
    try {
      setEnviandoFormulario(true);

      // Validaciones existentes...
      if (!nuevoServicio.titulo || !nuevoServicio.categoria || !nuevoServicio.ruc) {
        alert('Por favor completa los campos obligatorios');
        return;
      }

      if (nuevoServicio.ruc.length !== 11 || !/^\d+$/.test(nuevoServicio.ruc)) {
        alert('El RUC debe tener exactamente 11 dígitos');
        return;
      }

      if (nuevoServicio.categoria === 'otros' && !nuevoServicio.categoria_personalizada) {
        alert('Por favor especifica el tipo de servicio en "Categoría Personalizada"');
        return;
      }

      const categoriaInfo = getCategoriaInfo(nuevoServicio.categoria, nuevoServicio.categoria_personalizada);

      let experienciaTexto = '';
      if (nuevoServicio.experiencia_anos || nuevoServicio.experiencia_meses) {
        const anos = parseInt(nuevoServicio.experiencia_anos) || 0;
        const meses = parseInt(nuevoServicio.experiencia_meses) || 0;
        
        if (anos > 0 && meses > 0) {
          experienciaTexto = `${anos} año${anos !== 1 ? 's' : ''} y ${meses} mes${meses !== 1 ? 'es' : ''}`;
        } else if (anos > 0) {
          experienciaTexto = `${anos} año${anos !== 1 ? 's' : ''}`;
        } else if (meses > 0) {
          experienciaTexto = `${meses} mes${meses !== 1 ? 'es' : ''}`;
        }
      }

      // GUARDAR EN SUPABASE
      const nuevoServicioData = {
        titulo: nuevoServicio.titulo.trim(),
        categoria: nuevoServicio.categoria,
        categoria_personalizada: nuevoServicio.categoria === 'otros' ? nuevoServicio.categoria_personalizada.trim() : null,
        descripcion: nuevoServicio.descripcion.trim() || 'Sin descripción disponible',
        ubicacion: nuevoServicio.ubicacion.trim() || 'No especificada',
        empresa: nuevoServicio.empresa.trim() || (user?.name + ' Services') || 'Empresa no especificada',
        ruc: nuevoServicio.ruc.trim(),
        telefono: nuevoServicio.telefono.trim() || null,
        email: nuevoServicio.email.trim() || user?.email || null,
        whatsapp: nuevoServicio.whatsapp.trim() || null,
        website: nuevoServicio.website.trim() || null,
        facebook: nuevoServicio.facebook.trim() || null,
        instagram: nuevoServicio.instagram.trim() || null,
        tiktok: nuevoServicio.tiktok.trim() || null,
        especialidades: nuevoServicio.especialidades ? nuevoServicio.especialidades.split(',').map(s => s.trim()).filter(s => s) : [],
        experiencia: experienciaTexto || 'No especificada',
        usuario_email: user?.email || null,
        likes: 0,
        imagen: categoriaInfo.imagen,
        estado: 'pendiente', // SIEMPRE PENDIENTE HASTA QUE ADMIN APRUEBE
        fecha_publicacion: new Date().toISOString()
      };

      const { data, error } = await supabase
        .from('servicios_proveedores')
        .insert([nuevoServicioData])
        .select();

      if (error) throw error;

      setModalPublicar(false);
      
      // Limpiar formulario
      setNuevoServicio({
        titulo: '', categoria: '', categoria_personalizada: '', descripcion: '',
        ubicacion: '', empresa: '', ruc: '', telefono: '', email: '',
        whatsapp: '', website: '', facebook: '', instagram: '', tiktok: '',
        especialidades: '', experiencia_anos: '', experiencia_meses: ''
      });

      alert('Servicio enviado para revisión. Será publicado después de la aprobación del administrador.');
      
      // Recargar servicios para mostrar el nuevo (solo si es admin)
      if (isAdmin) {
        loadServicios();
      }
      
    } catch (error) {
      console.error('Error publishing service:', error);
      alert('Error al publicar el servicio: ' + error.message);
    } finally {
      setEnviandoFormulario(false);
    }
  };

  if (error) {
    return (
      <Container fluid className="py-4">
        <Alert color="danger">
          <h4>Error</h4>
          <p>{error}</p>
          <Button color="danger" onClick={loadServicios}>
            🔄 Reintentar
          </Button>
        </Alert>
      </Container>
    );
  }

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh'
    }}>
      {/* CSS para mejorar los dropdowns */}
      <style jsx>{`
        .dropdown-menu {
          z-index: 1050 !important;
        }
        
        .dropdown {
          position: relative !important;
        }
        
        .dropdown-toggle:focus {
          box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25) !important;
        }
        
        .dropdown-item:hover {
          background-color: #f8f9fa !important;
        }
      `}</style>

      <Container fluid className="py-5 px-4">
        {/* Hero Section */}
        <div className="text-center mb-5">
          <div className="mb-4" style={{ fontSize: '4rem' }}>
            🏪
          </div>
          <h1 className="display-4 fw-bold text-white mb-3" style={{ 
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
            fontSize: '3.5rem'
          }}>
            Redes de Proveedores
          </h1>
          <p className="lead text-white mb-4" style={{ 
            fontSize: '1.3rem',
            textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            Publica tus servicios y encuentra proveedores confiables en un solo lugar. Crea alianzas estratégicas y lleva tus proyectos al siguiente nivel.
          </p>
         
          <Button
            color="warning"
            size="lg"
            onClick={() => setModalPublicar(true)}
            style={{
              borderRadius: '50px',
              fontWeight: '700',
              padding: '15px 40px',
              fontSize: '1.2rem',
              border: 'none',
              boxShadow: '0 8px 25px rgba(255,193,7,0.4)',
              transform: 'scale(1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.boxShadow = '0 12px 35px rgba(255,193,7,0.6)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = '0 8px 25px rgba(255,193,7,0.4)';
            }}
          >
            ✨ Publica tus servicios
          </Button>
        </div>

        {/* Filtros con diseño moderno - VERSIÓN CORREGIDA */}
        <Card className="shadow-lg border-0 mb-5" style={{ 
          borderRadius: '25px',
          background: 'rgba(255,255,255,0.95)',
          backdropFilter: 'blur(10px)'
        }}>
          <CardBody className="p-4">
            <h5 className="fw-bold mb-4 text-center">🔍 Encuentra tu Proveedor Ideal</h5>
            <Row className="align-items-end">
              <Col lg={3} md={6} className="mb-3">
                <Label className="fw-bold mb-2 text-primary">🔍 Buscar</Label>
                <InputGroup size="lg">
                  <InputGroupText style={{ 
                    backgroundColor: '#f8f9fa',
                    border: 'none',
                    borderRadius: '15px 0 0 15px'
                  }}>
                    🔍
                  </InputGroupText>
                  <Input
                    type="text"
                    placeholder="Buscar servicios, empresas..."
                    value={filtroBusqueda}
                    onChange={(e) => setFiltroBusqueda(e.target.value)}
                    style={{ 
                      border: 'none',
                      borderRadius: '0 15px 15px 0',
                      fontSize: '1rem'
                    }}
                  />
                </InputGroup>
              </Col>

              <Col lg={2} md={6} className="mb-3">
                <Label className="fw-bold mb-2 text-primary">📍 Ubicación</Label>
                <Input
                  type="text"
                  size="lg"
                  placeholder="Lima, Arequipa..."
                  value={filtroUbicacion}
                  onChange={(e) => setFiltroUbicacion(e.target.value)}
                  style={{ 
                    borderRadius: '15px',
                    border: 'none',
                    backgroundColor: '#f8f9fa'
                  }}
                />
              </Col>

              <Col lg={3} md={6} className="mb-3" style={{ position: 'relative', zIndex: 1000 }}>
                <Label className="fw-bold mb-2 text-primary">🏷️ Categoría</Label>
                <Dropdown 
                  isOpen={dropdownCategoria} 
                  toggle={() => setDropdownCategoria(!dropdownCategoria)}
                  style={{ position: 'relative', zIndex: 1000 }}
                >
                  <DropdownToggle 
                    caret 
                    size="lg"
                    style={{ 
                      width: '100%', 
                      textAlign: 'left', 
                      borderRadius: '15px',
                      border: 'none',
                      backgroundColor: '#f8f9fa', // CORREGIDO: fondo igual a otros filtros
                      color: '#495057', // CORREGIDO: texto visible
                      fontSize: '1rem'
                    }}
                  >
                    {filtroCategoria ? getCategoriaInfo(filtroCategoria).nombre : 'Todas las categorías'}
                  </DropdownToggle>
                  <DropdownMenu 
                    style={{ 
                      width: '100%', 
                      borderRadius: '15px',
                      border: 'none',
                      boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                      zIndex: 1050, // CORREGIDO: z-index más alto
                      position: 'absolute',
                      top: '100%',
                      left: 0
                    }}
                  >
                    <DropdownItem 
                      onClick={() => setFiltroCategoria('')}
                      style={{ 
                        borderRadius: '10px',
                        margin: '5px',
                        fontSize: '0.95rem'
                      }}
                    >
                      Todas las categorías
                    </DropdownItem>
                    {categorias.map(categoria => (
                      <DropdownItem 
                        key={categoria.id} 
                        onClick={() => setFiltroCategoria(categoria.id)}
                        style={{ 
                          borderRadius: '10px',
                          margin: '5px',
                          fontSize: '0.95rem'
                        }}
                      >
                        {categoria.icono} {categoria.nombre}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>

              <Col lg={2} md={6} className="mb-3" style={{ position: 'relative', zIndex: 999 }}>
                <Label className="fw-bold mb-2 text-primary">🔄 Ordenar</Label>
                <Dropdown 
                  isOpen={dropdownOrden} 
                  toggle={() => setDropdownOrden(!dropdownOrden)}
                  style={{ position: 'relative', zIndex: 999 }}
                >
                  <DropdownToggle 
                    caret 
                    size="lg"
                    style={{ 
                      width: '100%', 
                      textAlign: 'left', 
                      borderRadius: '15px',
                      border: 'none',
                      backgroundColor: '#f8f9fa', // CORREGIDO: fondo igual a otros filtros
                      color: '#495057', // CORREGIDO: texto visible
                      fontSize: '1rem'
                    }}
                  >
                    {ordenamiento === 'recientes' && '🆕 Más Recientes'}
                    {ordenamiento === 'likes' && '🔥 Más Populares'}
                  </DropdownToggle>
                  <DropdownMenu 
                    style={{ 
                      width: '100%', 
                      borderRadius: '15px',
                      border: 'none',
                      boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                      zIndex: 1040, // CORREGIDO: z-index más alto
                      position: 'absolute',
                      top: '100%',
                      left: 0
                    }}
                  >
                    <DropdownItem 
                      onClick={() => setOrdenamiento('recientes')}
                      style={{ 
                        borderRadius: '10px',
                        margin: '5px',
                        fontSize: '0.95rem'
                      }}
                    >
                      🆕 Más Recientes
                    </DropdownItem>
                    <DropdownItem 
                      onClick={() => setOrdenamiento('likes')}
                      style={{ 
                        borderRadius: '10px',
                        margin: '5px',
                        fontSize: '0.95rem'
                      }}
                    >
                      🔥 Más Populares
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Col>

              <Col lg={2} md={12} className="mb-3">
                <Button
                  color="outline-primary"
                  size="lg"
                  onClick={() => {
                    setFiltroCategoria('');
                    setFiltroBusqueda('');
                    setFiltroUbicacion('');
                    setOrdenamiento('recientes');
                    setCurrentPage(1);
                  }}
                  style={{ 
                    width: '100%', 
                    borderRadius: '15px',
                    fontWeight: '600'
                  }}
                >
                  🗑️ Limpiar
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Grid de Servicios */}
        {loading ? (
          <div className="text-center py-5">
            <Spinner color="light" style={{ width: '4rem', height: '4rem' }} />
            <h4 className="mt-4 text-white">Cargando proveedores...</h4>
          </div>
        ) : serviciosPaginados.length > 0 ? (
          <>
            <Row>
              {serviciosPaginados.map(servicio => {
                const categoriaInfo = getCategoriaInfo(servicio.categoria, servicio.categoria_personalizada);
                
                return (
                  <Col xl={3} lg={4} md={6} className="mb-4" key={servicio.id}>
                    <Card 
                      className="h-100 shadow-lg border-0" 
                      style={{ 
                        borderRadius: '25px',
                        transition: 'all 0.4s ease',
                        cursor: 'pointer',
                        opacity: servicio.estado === 'rechazado' ? 0.6 : 1,
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0) scale(1)';
                        e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.15)';
                      }}
                    >
                      {/* Imagen del servicio con overlay */}
                      <div style={{ 
                        height: '200px', 
                        backgroundImage: `url(${servicio.imagen})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: '25px 25px 0 0',
                        position: 'relative'
                      }}>
                        {/* Overlay gradient */}
                        <div style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: 'linear-gradient(45deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.3) 100%)',
                          borderRadius: '25px 25px 0 0'
                        }}></div>
                        
                        {/* Badge de categoría */}
                        <div style={{
                          position: 'absolute',
                          top: '15px',
                          left: '15px',
                          zIndex: 2
                        }}>
                          <Badge 
                            style={{ 
                              background: categoriaInfo.color,
                              fontSize: '12px',
                              padding: '8px 16px',
                              borderRadius: '25px',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                            }}
                          >
                            {categoriaInfo.icono} {categoriaInfo.nombre}
                          </Badge>
                        </div>
                        
                        {/* Likes */}
                        <div style={{
                          position: 'absolute',
                          top: '15px',
                          right: '15px',
                          zIndex: 2
                        }}>
                          <Badge 
                            color="light"
                            style={{ 
                              fontSize: '12px',
                              padding: '8px 12px',
                              borderRadius: '20px',
                              backgroundColor: 'rgba(255,255,255,0.9)',
                              color: '#333'
                            }}
                          >
                            ❤️ {servicio.likes}
                          </Badge>
                        </div>
                        
                        {/* Estado del servicio (solo admin) */}
                        {isAdmin && (
                          <div style={{
                            position: 'absolute',
                            bottom: '15px',
                            left: '15px',
                            zIndex: 2
                          }}>
                            {getEstadoBadge(servicio.estado)}
                          </div>
                        )}
                      </div>

                      <CardBody className="p-4">
                        {/* Título y empresa */}
                        <div className="mb-3">
                          <h5 className="fw-bold mb-2" style={{ 
                            fontSize: '1.2rem',
                            lineHeight: '1.3',
                            minHeight: '3rem',
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            color: '#2c3e50'
                          }}>
                            {servicio.titulo}
                          </h5>
                          
                          <div className="d-flex align-items-center mb-2">
                            <div className="me-2" style={{ fontSize: '1.2rem' }}>🏢</div>
                            <span className="text-muted fw-medium" style={{ fontSize: '0.95rem' }}>
                              {servicio.empresa || 'Empresa no especificada'}
                            </span>
                          </div>
                        </div>

                        {/* Descripción */}
                        <p className="text-muted mb-3" style={{ 
                          fontSize: '0.9rem',
                          lineHeight: '1.5',
                          minHeight: '4.5rem',
                          overflow: 'hidden',
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical'
                        }}>
                          {servicio.descripcion || 'Sin descripción disponible'}
                        </p>

                        {/* Información adicional */}
                        <div className="mb-3">
                          <div className="d-flex align-items-center mb-2">
                            <span style={{ fontSize: '1rem' }}>📍</span>
                            <small className="text-muted ms-2">{servicio.ubicacion || 'Ubicación no especificada'}</small>
                          </div>
                          <div className="d-flex align-items-center">
                            <span style={{ fontSize: '1rem' }}>⏱️</span>
                            <small className="text-muted ms-2">{servicio.experiencia || 'Experiencia no especificada'}</small>
                          </div>
                        </div>

                        {/* Especialidades */}
                        <div className="mb-4">
                          <div className="d-flex flex-wrap gap-1">
                            {(servicio.especialidades || []).slice(0, 2).map((esp, index) => (
                              <Badge 
                                key={index}
                                style={{ 
                                  fontSize: '11px', 
                                  padding: '6px 12px',
                                  background: 'linear-gradient(45deg, #667eea, #764ba2)',
                                  color: 'white',
                                  borderRadius: '15px',
                                  border: 'none'
                                }}
                              >
                                {esp}
                              </Badge>
                            ))}
                            {(servicio.especialidades || []).length > 2 && (
                              <Badge 
                                style={{ 
                                  fontSize: '11px', 
                                  padding: '6px 12px',
                                  backgroundColor: '#6c757d',
                                  borderRadius: '15px'
                                }}
                              >
                                +{servicio.especialidades.length - 2} más
                              </Badge>
                            )}
                          </div>
                        </div>

                        {/* Botones de acción */}
                        <div className="d-grid gap-2">
                          <Button
                            color="primary"
                            onClick={() => {
                              setServicioSeleccionado(servicio);
                              setModalDetalles(true);
                            }}
                            style={{ 
                              borderRadius: '15px',
                              fontWeight: '600',
                              padding: '12px',
                              background: 'linear-gradient(45deg, #667eea, #764ba2)',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(102,126,234,0.3)'
                            }}
                          >
                            👁️ Ver Detalles Completos
                          </Button>
                          
                          {servicio.estado === 'aprobado' && (
                            <Button
                              color="success"
                              onClick={() => {
                                setServicioSeleccionado(servicio);
                                setModalContactar(true);
                              }}
                              style={{ 
                                borderRadius: '15px',
                                fontWeight: '600',
                                padding: '12px',
                                background: 'linear-gradient(45deg, #56ab2f, #a8e6cf)',
                                border: 'none',
                                boxShadow: '0 4px 15px rgba(86,171,47,0.3)'
                              }}
                            >
                              💬 Contactar Ahora
                            </Button>
                          )}
                        </div>

                        {/* Botones de administrador */}
                        {isAdmin && (
                          <div className="d-flex gap-2 mt-3">
                            {servicio.estado === 'pendiente' && (
                              <>
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() => handleAprobarServicio(servicio.id)}
                                  style={{ 
                                    borderRadius: '12px',
                                    fontWeight: '600',
                                    flex: 1
                                  }}
                                >
                                  ✅ Aprobar
                                </Button>
                                <Button
                                  color="warning"
                                  size="sm"
                                  onClick={() => handleRechazarServicio(servicio.id)}
                                  style={{ 
                                    borderRadius: '12px',
                                    fontWeight: '600',
                                    flex: 1
                                  }}
                                >
                                  ❌ Rechazar
                                </Button>
                              </>
                            )}
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleEliminarServicio(servicio.id)}
                              style={{ 
                                borderRadius: '12px',
                                fontWeight: '600',
                                flex: servicio.estado === 'pendiente' ? 1 : 2
                              }}
                            >
                              🗑️ Eliminar
                            </Button>
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                );
              })}
            </Row>

            {/* Paginación moderna */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-5">
                <Card style={{ 
                  borderRadius: '25px',
                  background: 'rgba(255,255,255,0.9)',
                  backdropFilter: 'blur(10px)',
                  border: 'none'
                }}>
                  <CardBody className="p-3">
                    <Pagination className="mb-0">
                      <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink 
                          previous 
                          onClick={() => setCurrentPage(currentPage - 1)}
                          style={{ borderRadius: '15px 0 0 15px' }}
                        />
                      </PaginationItem>
                      
                      {[...Array(Math.min(totalPages, 5))].map((_, index) => {
                        let pageNum;
                        if (totalPages <= 5) {
                          pageNum = index + 1;
                        } else if (currentPage <= 3) {
                          pageNum = index + 1;
                        } else if (currentPage >= totalPages - 2) {
                          pageNum = totalPages - 4 + index;
                        } else {
                          pageNum = currentPage - 2 + index;
                        }
                        
                        return (
                          <PaginationItem key={pageNum} active={currentPage === pageNum}>
                            <PaginationLink 
                              onClick={() => setCurrentPage(pageNum)}
                              style={{
                                backgroundColor: currentPage === pageNum ? '#667eea' : 'transparent',
                                borderColor: '#667eea'
                              }}
                            >
                              {pageNum}
                            </PaginationLink>
                          </PaginationItem>
                        );
                      })}
                      
                      <PaginationItem disabled={currentPage === totalPages}>
                        <PaginationLink 
                          next 
                          onClick={() => setCurrentPage(currentPage + 1)}
                          style={{ borderRadius: '0 15px 15px 0' }}
                        />
                      </PaginationItem>
                    </Pagination>
                  </CardBody>
                </Card>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-5">
            <Card style={{ 
              borderRadius: '25px',
              background: 'rgba(255,255,255,0.9)',
              backdropFilter: 'blur(10px)',
              border: 'none',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              <CardBody className="p-5">
                <div style={{ fontSize: '5rem', opacity: 0.3 }}>🔍</div>
                <h3 className="text-muted mb-3">No se encontraron proveedores</h3>
                <p className="text-muted mb-4">
                  {isAdmin 
                    ? 'No hay servicios que coincidan con los filtros aplicados' 
                    : 'Intenta ajustar los filtros de búsqueda o sé el primero en unirte'
                  }
                </p>
                <div className="d-flex gap-3 justify-content-center">
                  <Button 
                    color="outline-primary" 
                    onClick={() => {
                      setFiltroCategoria('');
                      setFiltroBusqueda('');
                      setFiltroUbicacion('');
                      setOrdenamiento('recientes');
                    }}
                    style={{ borderRadius: '15px' }}
                  >
                    🗑️ Limpiar Filtros
                  </Button>
                  <Button 
                    color="warning" 
                    onClick={() => setModalPublicar(true)}
                    style={{ borderRadius: '15px' }}
                  >
                    ✨ Únete Ahora
                  </Button>
                </div>
              </CardBody>
            </Card>
          </div>
        )}

        {/* Modal para Publicar Servicio */}
        <Modal isOpen={modalPublicar} toggle={() => setModalPublicar(false)} size="xl">
          <ModalHeader 
            toggle={() => setModalPublicar(false)} 
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              borderRadius: '20px 20px 0 0'
            }}
          >
            <div className="d-flex align-items-center">
              <span className="me-2" style={{ fontSize: '1.5rem' }}>✨</span>
              Únete como Proveedor Premium
            </div>
          </ModalHeader>
          <Form onSubmit={handlePublicarServicio}>
            <ModalBody className="p-5" style={{ backgroundColor: '#f8f9fa' }}>
              <Alert color="info" className="mb-4" style={{ borderRadius: '15px' }}>
                <h6 className="fw-bold">💎 Beneficios de ser Proveedor Nuvia</h6>
                <div className="small">
                  ✅ <strong>Verificación :</strong> Tu servicio será revisado<br/>
                  ✅ <strong>Exposición garantizada:</strong> Acceso a cientos de potenciales clientes<br/>
                </div>
              </Alert>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">📝 Título del Servicio *</Label>
                    <Input
                      type="text"
                      value={nuevoServicio.titulo}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, titulo: e.target.value})}
                      placeholder="Ej: Construcción de Infraestructura Educativa Premium"
                      required
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">🏷️ Categoría *</Label>
                    <Input
                      type="select"
                      value={nuevoServicio.categoria}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, categoria: e.target.value})}
                      required
                      style={{ borderRadius: '12px', padding: '12px' }}
                    >
                      <option value="">Seleccionar categoría</option>
                      {categorias.map(cat => (
                        <option key={cat.id} value={cat.id}>
                          {cat.icono} {cat.nombre}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              {nuevoServicio.categoria === 'otros' && (
                <FormGroup>
                  <Label className="fw-bold text-primary">✏️ Especifica tu Categoría *</Label>
                  <Input
                    type="text"
                    value={nuevoServicio.categoria_personalizada}
                    onChange={(e) => setNuevoServicio({...nuevoServicio, categoria_personalizada: e.target.value})}
                    placeholder="Ej: Arquitectura, Marketing Digital, Asesoría Legal..."
                    required
                    style={{ borderRadius: '12px', padding: '12px' }}
                  />
                  <small className="text-muted">Describe el tipo de servicio que ofreces</small>
                </FormGroup>
              )}

              <FormGroup>
                <Label className="fw-bold text-primary">📄 Descripción del Servicio</Label>
                <Input
                  type="textarea"
                  rows="4"
                  value={nuevoServicio.descripcion}
                  onChange={(e) => setNuevoServicio({...nuevoServicio, descripcion: e.target.value})}
                  placeholder="Describe detalladamente tu servicio, experiencia y ventajas competitivas..."
                  style={{ borderRadius: '12px', padding: '12px' }}
                />
              </FormGroup>

              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">📍 Ubicación</Label>
                    <Input
                      type="text"
                      value={nuevoServicio.ubicacion}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, ubicacion: e.target.value})}
                      placeholder="Lima, Perú"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">⏱️ Años de Experiencia</Label>
                    <Input
                      type="number"
                      min="0"
                      max="50"
                      value={nuevoServicio.experiencia_anos}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, experiencia_anos: e.target.value})}
                      placeholder="5"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">📅 Meses adicionales</Label>
                    <Input
                      type="number"
                      min="0"
                      max="11"
                      value={nuevoServicio.experiencia_meses}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, experiencia_meses: e.target.value})}
                      placeholder="6"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">🏢 Nombre de Empresa</Label>
                    <Input
                      type="text"
                      value={nuevoServicio.empresa}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, empresa: e.target.value})}
                      placeholder="Mi Empresa SAC"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">🆔 RUC *</Label>
                    <Input
                      type="text"
                      value={nuevoServicio.ruc}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, ruc: e.target.value.replace(/\D/g, '')})}
                      placeholder="20123456789"
                      maxLength="11"
                      required
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                    <small className="text-muted">Registro Único de Contribuyentes (11 dígitos)</small>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">📞 Teléfono</Label>
                    <Input
                      type="text"
                      value={nuevoServicio.telefono}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, telefono: e.target.value})}
                      placeholder="+51 999 888 777"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">📧 Email</Label>
                    <Input
                      type="email"
                      value={nuevoServicio.email}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, email: e.target.value})}
                      placeholder="contacto@empresa.com"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">📱 WhatsApp</Label>
                    <Input
                      type="text"
                      value={nuevoServicio.whatsapp}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, whatsapp: e.target.value})}
                      placeholder="+51999888777"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label className="fw-bold text-primary">🌐 Sitio Web</Label>
                    <Input
                      type="url"
                      value={nuevoServicio.website}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, website: e.target.value})}
                      placeholder="www.empresa.com"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <h6 className="fw-bold text-primary mt-4 mb-3">📱 Redes Sociales (Opcional)</h6>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label className="fw-bold">📘 Facebook</Label>
                    <Input
                      type="url"
                      value={nuevoServicio.facebook}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, facebook: e.target.value})}
                      placeholder="https://www.facebook.com/tupagina"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label className="fw-bold">📷 Instagram</Label>
                    <Input
                      type="url"
                      value={nuevoServicio.instagram}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, instagram: e.target.value})}
                      placeholder="https://www.instagram.com/tuusuario"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label className="fw-bold">🎵 TikTok</Label>
                    <Input
                      type="url"
                      value={nuevoServicio.tiktok}
                      onChange={(e) => setNuevoServicio({...nuevoServicio, tiktok: e.target.value})}
                      placeholder="https://www.tiktok.com/@tuusuario"
                      style={{ borderRadius: '12px', padding: '12px' }}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label className="fw-bold text-primary">🎯 Especialidades (separadas por comas)</Label>
                <Input
                  type="text"
                  value={nuevoServicio.especialidades}
                  onChange={(e) => setNuevoServicio({...nuevoServicio, especialidades: e.target.value})}
                  placeholder="Colegios, Universidades, Centros de salud, Proyectos grandes"
                  style={{ borderRadius: '12px', padding: '12px' }}
                />
                <small className="text-muted">
                  Ejemplo: Construcción de colegios, Remodelaciones, Proyectos industriales
                </small>
              </FormGroup>
            </ModalBody>
            <ModalFooter style={{ backgroundColor: '#f8f9fa', borderRadius: '0 0 20px 20px' }}>
              <Button 
                color="secondary" 
                onClick={() => setModalPublicar(false)}
                style={{ borderRadius: '15px' }}
              >
                ❌ Cancelar
              </Button>
              <Button 
                color="primary" 
                type="submit" 
                disabled={enviandoFormulario}
                style={{ 
                  borderRadius: '15px',
                  background: 'linear-gradient(45deg, #667eea, #764ba2)',
                  border: 'none'
                }}
              >
                {enviandoFormulario ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Enviando...
                  </>
                ) : (
                  '🚀 Enviar para Aprobación'
                )}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        {/* Modal para Ver Detalles - Versión mejorada */}
        <Modal isOpen={modalDetalles} toggle={() => setModalDetalles(false)} size="xl">
          {servicioSeleccionado && (
            <>
              <ModalHeader 
                toggle={() => setModalDetalles(false)} 
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  borderRadius: '20px 20px 0 0'
                }}
              >
                <div className="d-flex align-items-center">
                  <span className="me-2" style={{ fontSize: '1.5rem' }}>👁️</span>
                  Detalles del Proveedor Premium
                </div>
              </ModalHeader>
              <ModalBody className="p-5" style={{ backgroundColor: '#f8f9fa' }}>
                <Row>
                  <Col lg={4}>
                    <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '20px' }}>
                      <div style={{ 
                        height: '250px',
                        backgroundImage: `url(${servicioSeleccionado.imagen})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: '20px 20px 0 0',
                        position: 'relative'
                      }}>
                        <div style={{
                          position: 'absolute',
                          top: '15px',
                          left: '15px'
                        }}>
                          <Badge 
                            style={{ 
                              background: getCategoriaInfo(servicioSeleccionado.categoria, servicioSeleccionado.categoria_personalizada).color,
                              fontSize: '13px',
                              padding: '10px 15px',
                              borderRadius: '25px',
                              border: 'none'
                            }}
                          >
                            {getCategoriaInfo(servicioSeleccionado.categoria, servicioSeleccionado.categoria_personalizada).icono} 
                            {getCategoriaInfo(servicioSeleccionado.categoria, servicioSeleccionado.categoria_personalizada).nombre}
                          </Badge>
                        </div>
                        {isAdmin && (
                          <div style={{
                            position: 'absolute',
                            bottom: '15px',
                            left: '15px'
                          }}>
                            {getEstadoBadge(servicioSeleccionado.estado)}
                          </div>
                        )}
                      </div>
                      <CardBody className="text-center p-4">
                        
                        {isAdmin && (
                          <small className="text-muted">
                            📧 {servicioSeleccionado.usuario_email || 'No especificado'}<br/>
                            📅 {new Date(servicioSeleccionado.created_at).toLocaleDateString('es-PE')}
                          </small>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                  
                  <Col lg={8}>
                    <Card className="shadow-sm border-0" style={{ borderRadius: '20px' }}>
                      <CardBody className="p-4">
                        <h2 className="fw-bold mb-3" style={{ color: '#2c3e50' }}>
                          {servicioSeleccionado.titulo}
                        </h2>
                        
                        <div className="row mb-4">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <h6 className="fw-bold text-primary">🏢 Empresa</h6>
                              <p className="mb-1">{servicioSeleccionado.empresa || 'No especificada'}</p>
                              {servicioSeleccionado.ruc && (
                                <small className="text-muted">🆔 RUC: {servicioSeleccionado.ruc}</small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <h6 className="fw-bold text-primary">📍 Ubicación</h6>
                              <p className="mb-0">{servicioSeleccionado.ubicacion || 'No especificada'}</p>
                            </div>
                          </div>
                        </div>

                        <div className="mb-4">
                          <h6 className="fw-bold text-primary">📄 Descripción del Servicio</h6>
                          <p className="text-muted" style={{ lineHeight: '1.6' }}>
                            {servicioSeleccionado.descripcion || 'Sin descripción disponible'}
                          </p>
                        </div>

                        <div className="mb-4">
                          <h6 className="fw-bold text-primary">⏱️ Experiencia</h6>
                          <p className="text-muted">{servicioSeleccionado.experiencia || 'No especificada'}</p>
                        </div>
                        
                        <div className="mb-4">
                          <h6 className="fw-bold text-primary">🎯 Especialidades</h6>
                          <div className="d-flex flex-wrap gap-2">
                            {(servicioSeleccionado.especialidades || []).map((esp, index) => (
                              <Badge 
                                key={index}
                                style={{ 
                                  fontSize: '12px', 
                                  padding: '8px 15px',
                                  background: 'linear-gradient(45deg, #667eea, #764ba2)',
                                  color: 'white',
                                  borderRadius: '20px',
                                  border: 'none'
                                }}
                              >
                                {esp}
                              </Badge>
                            ))}
                            {(!servicioSeleccionado.especialidades || servicioSeleccionado.especialidades.length === 0) && (
                              <p className="text-muted">No especificadas</p>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter style={{ backgroundColor: '#f8f9fa', borderRadius: '0 0 20px 20px' }}>
                <Button 
                  color="secondary" 
                  onClick={() => setModalDetalles(false)}
                  style={{ borderRadius: '15px' }}
                >
                  ❌ Cerrar
                </Button>
                {servicioSeleccionado.estado === 'aprobado' && (
                  <Button 
                    color="success" 
                    onClick={() => {
                      setModalDetalles(false);
                      setModalContactar(true);
                    }}
                    style={{ 
                      borderRadius: '15px',
                      background: 'linear-gradient(45deg, #56ab2f, #a8e6cf)',
                      border: 'none'
                    }}
                  >
                    💬 Contactar Proveedor
                  </Button>
                )}
              </ModalFooter>
            </>
          )}
        </Modal>

        {/* Modal para Contactar - Versión mejorada */}
        <Modal isOpen={modalContactar} toggle={() => setModalContactar(false)} size="md">
          {servicioSeleccionado && (
            <>
              <ModalHeader 
                toggle={() => setModalContactar(false)} 
                style={{
                  background: 'linear-gradient(135deg, #56ab2f 0%, #a8e6cf 100%)',
                  color: 'white',
                  borderRadius: '20px 20px 0 0'
                }}
              >
                <div className="d-flex align-items-center">
                  <span className="me-2" style={{ fontSize: '1.5rem' }}>💬</span>
                  Contactar Proveedor
                </div>
              </ModalHeader>
              <ModalBody className="p-4" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="text-center mb-4">
                  <h4 className="fw-bold text-primary">{servicioSeleccionado.empresa || 'Empresa'}</h4>
                  <p className="text-muted">{servicioSeleccionado.titulo}</p>
                </div>

                <div className="d-grid gap-3">
                  {servicioSeleccionado.whatsapp && (
                    <Button 
                      color="success" 
                      size="lg"
                      onClick={() => window.open(`https://wa.me/${servicioSeleccionado.whatsapp?.replace(/[^0-9]/g, '')}?text=Hola, encontré su servicio en el Portal de Nuvia Consulting y estoy interesado en: ${servicioSeleccionado.titulo}`, '_blank')}
                      style={{ 
                        borderRadius: '15px',
                        padding: '15px',
                        fontWeight: '600'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <FaWhatsapp className="me-2" style={{ fontSize: '1.3rem' }} />
                        WhatsApp: {servicioSeleccionado.whatsapp}
                      </div>
                    </Button>
                  )}

                  {servicioSeleccionado.telefono && (
                    <Button 
                      color="primary" 
                      size="lg"
                      onClick={() => window.open(`tel:${servicioSeleccionado.telefono}`, '_blank')}
                      style={{ 
                        borderRadius: '15px',
                        padding: '15px',
                        fontWeight: '600'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="me-2" style={{ fontSize: '1.2rem' }}>📞</span>
                        Teléfono: {servicioSeleccionado.telefono}
                      </div>
                    </Button>
                  )}

                  {servicioSeleccionado.email && (
                    <Button 
                      color="info" 
                      size="lg"
                      onClick={() => window.open(`mailto:${servicioSeleccionado.email}?subject=Consulta desde Portal Nuvia Consulting - ${servicioSeleccionado.titulo}&body=Estimados,\n\nEspero se encuentren bien. Los contacto desde el Portal de Proveedores de Nuvia Consulting, donde encontré su servicio: "${servicioSeleccionado.titulo}".\n\nMe gustaría obtener más información sobre:\n- \n- \n- \n\nQuedo atento a su respuesta.\n\nSaludos cordiales.`, '_blank')}
                      style={{ 
                        borderRadius: '15px',
                        padding: '15px',
                        fontWeight: '600'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="me-2" style={{ fontSize: '1.2rem' }}>📧</span>
                        Email: {servicioSeleccionado.email}
                      </div>
                    </Button>
                  )}

                  {servicioSeleccionado.facebook && (
                    <Button 
                      color="primary" 
                      size="lg"
                      onClick={() => window.open(servicioSeleccionado.facebook.startsWith('http') ? servicioSeleccionado.facebook : `https://${servicioSeleccionado.facebook}`, '_blank')}
                      style={{ 
                        borderRadius: '15px',
                        padding: '15px',
                        fontWeight: '600',
                        backgroundColor: '#1877F2',
                        borderColor: '#1877F2'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <FaFacebook className="me-2" style={{ fontSize: '1.3rem' }} />
                        Facebook
                      </div>
                    </Button>
                  )}

                  {servicioSeleccionado.instagram && (
                    <Button 
                      color="danger" 
                      size="lg"
                      onClick={() => window.open(servicioSeleccionado.instagram.startsWith('http') ? servicioSeleccionado.instagram : `https://${servicioSeleccionado.instagram}`, '_blank')}
                      style={{ 
                        borderRadius: '15px',
                        padding: '15px',
                        fontWeight: '600',
                        background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
                        border: 'none'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <FaInstagram className="me-2" style={{ fontSize: '1.3rem' }} />
                        Instagram
                      </div>
                    </Button>
                  )}

                  {servicioSeleccionado.tiktok && (
                    <Button 
                      color="dark" 
                      size="lg"
                      onClick={() => window.open(servicioSeleccionado.tiktok.startsWith('http') ? servicioSeleccionado.tiktok : `https://${servicioSeleccionado.tiktok}`, '_blank')}
                      style={{ 
                        borderRadius: '15px',
                        padding: '15px',
                        fontWeight: '600',
                        backgroundColor: '#000000',
                        borderColor: '#000000'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <FaTiktok className="me-2" style={{ fontSize: '1.3rem' }} />
                        TikTok
                      </div>
                    </Button>
                  )}

                  {servicioSeleccionado.website && (
                    <Button 
                      color="warning" 
                      size="lg"
                      onClick={() => window.open(servicioSeleccionado.website.startsWith('http') ? servicioSeleccionado.website : `https://${servicioSeleccionado.website}`, '_blank')}
                      style={{ 
                        borderRadius: '15px',
                        padding: '15px',
                        fontWeight: '600'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="me-2" style={{ fontSize: '1.2rem' }}>🌐</span>
                        Sitio Web
                      </div>
                    </Button>
                  )}
                </div>

                <Alert color="warning" className="mt-4" style={{ borderRadius: '15px' }}>
                  <h6 className="fw-bold">⚠️ Importante - Términos de Uso</h6>
                  <small>
                    <strong>Nuvia Consulting valida los datos registrados</strong> de este proveedor, pero 
                    <strong> no se hace responsable de las transacciones comerciales</strong> que realices con ellos. 
                    <br/><br/>
                    📋 <strong>Recomendamos:</strong> Realizar compras de manera presencial, solicitar 
                    fotos, cotizaciones detalladas y verificar referencias antes de cualquier transacción.
                  </small>
                </Alert>
              </ModalBody>
              <ModalFooter style={{ backgroundColor: '#f8f9fa', borderRadius: '0 0 20px 20px' }}>
                <Button 
                  color="secondary" 
                  onClick={() => setModalContactar(false)}
                  style={{ borderRadius: '15px' }}
                >
                  ❌ Cerrar
                </Button>
              </ModalFooter>
            </>
          )}
        </Modal>
      </Container>
    </div>
  );
};

export default CatalogoProveedores;